import {FRIEND_REFERAL_URL_PREFIX, PARTNER_REFERAL_URL_PREFIX} from "../../constants/partner";

/**
 * Открыт ли сайт по реферальной ссылке — партнерской
 * ({домен}/referal/partner/{id}) или дружеской ({домен}/referal/friend/{code},
 * возможно с хвостом /lobby/{lobbyId}).
 *
 * Нужен в двух местах: при разборе ссылки на старте и при очистке адреса после
 * того, как метка отработала (см. App).
 *
 * @param {string} pathname - window.location.pathname
 * @returns {boolean}
 */
export const checkIfReferalPath = (pathname) => {
  return [PARTNER_REFERAL_URL_PREFIX, FRIEND_REFERAL_URL_PREFIX]
    .some((prefix) => String(pathname || '').startsWith(prefix));
};
